import { CSSObject } from "@emotion/react";
import { Colors } from "../../ui-library/design-tokens/colors";
import { Fonts } from "../../ui-library/design-tokens/fonts";
import { grid } from "../../ui-library/design-tokens/grid";
import { Device } from "../../ui-library/design-tokens/media-queries";

const root: CSSObject = {
  [Device.Mobile]: {
    marginLeft: grid(-2),
    marginRight: grid(-2),
  },
};

const colAlignment: CSSObject[] = [
  { textAlign: "center" },
  { textAlign: "left" },
  { textAlign: "left" },
  { textAlign: "right" },
  { textAlign: "right", width: 140 },
  { textAlign: "right", width: 100 },
];

const rank: CSSObject = {
  fontSize: 14,
  fontWeight: Fonts.Weight.SemiBold,
  color: Colors.MidGrey,
};

const nameContainer: CSSObject = {
  display: "flex",
  alignItems: "center",
};

const nameColLeft: CSSObject = {
  textAlign: "center",
  marginRight: grid(1.5),
};

const imageContainer: CSSObject = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: grid(2),
  height: grid(2),

  [Device.DesktopTablet]: {
    width: grid(4),
    height: grid(4),
  },
};

const image: CSSObject = {
  objectFit: "contain",
  maxWidth: "100%",
  maxHeight: "100%",
};

const nameColRank: CSSObject = {
  fontSize: 10,
  fontWeight: Fonts.Weight.SemiBold,
  color: Colors.MidGrey,
  marginTop: grid(0.5),

  [Device.DesktopTablet]: {
    display: "none",
  },
};

const name: CSSObject = {
  fontWeight: Fonts.Weight.Bold,
  color: Colors.Black,
  marginBottom: 3,

  ":hover": {
    color: Colors.Blue,
  },

  [Device.Mobile]: {
    maxWidth: 120,
    fontSize: 14,
    whiteSpace: "nowrap",
  },
};

const type: CSSObject = {
  fontSize: 12,
  fontWeight: Fonts.Weight.SemiBold,
  color: Colors.MidGrey,
};

const ticker: CSSObject = {
  fontSize: 14,
  fontWeight: Fonts.Weight.SemiBold,
  wordBreak: "break-word",
  minWidth: grid(10),
};

const label: CSSObject = {
  fontSize: 14,
  fontWeight: Fonts.Weight.SemiBold,
  whiteSpace: "nowrap",
};

const styles = {
  root,
  colAlignment,
  rank,
  nameContainer,
  nameColLeft,
  imageContainer,
  image,
  nameColRank,
  name,
  type,
  ticker,
  label,
};

export default styles;
